import React from "react";
import { InputBase } from "../ui/input-base";

const PostalCodeInput = React.forwardRef(
  ({ className, value, onChange, error, ...props }, ref) => {
    const handleChange = (e) => {
      const inputValue = e.target.value;
      const cleaned = inputValue.replace(/\D/g, "");
      if (cleaned.length <= 9) {
        onChange(cleaned);
      }
    };

    const formatNumber = (value) => {
      let postalCode = ("" + value).replace(/\D/g, "");
      const match = postalCode.match(/^(\d{1,5})(\d{0,4})$/);
      if (match) {
        postalCode = `${match[1]}${match[2] ? "-" : ""}${match[2]}`;
      }
      return postalCode;
    };

    return (
      <InputBase
        type="text"
        value={value ? formatNumber(value) : ""}
        onChange={handleChange}
        className={className}
        ref={ref}
        {...props}
      />
    );
  }
);
PostalCodeInput.displayName = "PostalCodeInput";

export { PostalCodeInput };
